import React, { Component } from 'react';
import ReactDOM from 'react-dom';
//import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';

export default class JobFullDetailsDriverDocuments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      driver_documents: props.driver_documents || null  ,
      data: props.data || null,
      isLoadingDriverDocuments: true,
    };

    this.handleJobDriverDocumentsChange = this.
    handleJobDriverDocumentsChange.bind(this);
    this.handleDriverDocumentDelete = this.handleDriverDocumentDelete.bind(this);
  }

  componentDidMount() {
    this.getDriverDocuments();
    Echo.channel(
      'jobs-table-'+this.state.data.id
    ).
    listen(
      'NewDriverDocument',
      (e) => {
        this.getDriverDocuments();
      }
    );
  }
  sendDocumentsMailToCustomer(e){
    return fetch('/api/v1/portal/jobs/'+this.state.data.id+'/send-documents-mail-to-customer',
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token
          , "Accept": 'application/json'
        },
      }
    ).then((response) => {
      if (response.ok) {
        alert('Mail sent to customer...');
      } else {
        let res = response.json();
        res.then((resJson) => {
          alert(resJson);
        });
        // alert('Unable to sent mail..');
      }
    }).catch((error) => { 
      alert('Unable to sent mail..'+error);
    });
  }
  handleJobDriverDocumentsChange(e) {
    let newJobDriverDocuments = e.target.value;
    let data = {...this.state.data};
    data.invoice_number = newJobDriverDocuments;
    this.setState({data});
  }

  getDriverDocuments() {
    let url = '/api/v1/portal/driver-documents/job/'+this.state.data.id;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token,
        "Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((driverDocumentsDataJson) => {
        this.setState({
          driver_documents: driverDocumentsDataJson,
          isLoadingDriverDocuments: false,
        })
      });
    });
  }

  handleDriverDocumentUpload(e) {
    const input = document.getElementById(
      'new_driver_document'
    );
    let file = input.files[0];
    const data = new FormData();
    data.append(
      'new_driver_document',
      file,
      file.name
    );
    return fetch(
      '/api/v1/portal/jobs/upload-new-driver-document/'+
       this.state.data.id,
      {
        method: 'POST',
        headers: {
          "Authorization": 'Bearer ' + window.api_token
          ,"Accept": 'application/json'
        },
        body: data,
      }).then(
        response =>console.log(response)
      ).then(
        success => console.log(success)
      ).catch(
        error => console.log(error)
      );
  }
  handleDriverDocumentDelete(e,docId,jobId){
     fetch('/api/v1/portal/jobs/delete-driver-document/'+docId,
      {
        method: 'POST',
        headers: {
          "Authorization": 'Bearer ' + window.api_token
          ,"Accept": 'application/json'
        },
        body: JSON.stringify({
          job_id: jobId
        }),
      }).then(response =>{
        console.log(response.status)
        if(response.status == 200){
          let Updateindex = this.state.driver_documents.findIndex(doc => doc.id == docId);
          this.state.driver_documents.splice(Updateindex, 1);
          this.setState({driver_documents:this.state.driver_documents});
          	//let infoModal = $('#infomodal');
	        //document.querySelector('#infomodallabel').innerHTML = 'Success';
	        //document.querySelector('#infomodal .modal-body').innerHTML = 'Driver documents deleted succesully.';
	        //infoModal.modal();
        }
      }
      ).catch(error => {
        console.log(error)
        let infoModal = $('#infomodal');
        document.querySelector('#infomodallabel').innerHTML = 'Error';
        document.querySelector('#infomodal .modal-body').innerHTML = error.message;
        infoModal.modal();
      });
      return false;
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }

  render() {
    let DriverDocuments = [];
	let handleDriverDocumentDelete = this.handleDriverDocumentDelete;
    if (this.state.driver_documents && this.state.driver_documents.length > 0) {
      this.state.driver_documents.forEach(function(i) {
      const trashStyle = {
          'font-size': '25px',
          'color': 'red',
        };
        DriverDocuments.push(
          <div className="row alert alert-info" key={"driver-documents-"+i.filename}>
              <div className="col-md-11">
                  <a href={i.filename}>
                    <i className="fa fa-file"></i>&nbsp;
                      [{i.created_at}] - {i.label}
                  </a>
              </div>
              <div className="col-md-1 text-right">
                  <a title="delete document" id={"row-doc-"+i.id} onClick={(e)=>handleDriverDocumentDelete(e,i.id,i.job_id)} style={{cursor:'pointer'}}>
                    <i className="fa fa-trash fa-lg"></i>
                  </a>
              </div>
          </div>
        )
      });
    }

    return (
      <div>
        <div className="row">
          <div className="col-md-3">
          </div>
          <div className="col-md-6 driver-documents-uploader-container">
            <p>
            <i className="fa fa-upload"></i>&nbsp;
            <input
              type="file"
              name="new_driver_document"
              id="new_driver_document"
            />
            </p>
            <p>
              <button
                className="btn btn-lg btn-primary"
                onClick={(e) => {
                  this.handleDriverDocumentUpload(e);
                }}
              >
                <i className="fa fa-upload"></i>&nbsp;
                Upload Now
              </button>
            </p>
          </div>
          <div className="col-md-3">
          </div>
        </div>


        {DriverDocuments}

        {(this.state.driver_documents && this.state.driver_documents.length > 0) ? 
                <button class="btn btn-dark btn-document dropoff font-16 text-uppercase" onClick={(e) => {this.sendDocumentsMailToCustomer(e)}}>SEND Driver Documents TO CUSTOMER</button>
                : ""}


      </div>
    );
  }
}